import { mapStores } from "pinia";

import { useSearchStore } from "@/stores";

const allowed = {
  dade: ["adjective", "article", "noun", "verb", "pronoun"],
  deda: ["adjective", "article", "noun", "verb", "pronoun"],

  daen: ["adjective", "noun", "verb"],
  enda: ["adjective", "noun", "verb"],

  dafr: ["adjective", "noun", "verb"],
  frda: ["adjective", "noun", "verb"]
};

export default {
  computed: {
    ...mapStores(useSearchStore),

    searchDirection() {
      return this.searchStore.searchDirection;
    },

    searchSourceLanguage() {
      return this.searchStore.searchSourceLanguage;
    }
  },
  methods: {
    showInflectionSchemeButton(element) {
      if (!element.inflectionScheme.json || allowed[this.searchDirection] === undefined) {
        return false;
      }

      return allowed[this.searchDirection].some(
        (wordClass) => element.inflectionScheme.json[wordClass]
      );
    }
  }
};
